import { useState } from 'react';
import { getDateString, getInitialDate } from './utils';

export function useDate(
  initialDate?: Date | string | null,
  defaultToCurrent = false
) {
  const [date, setDate] = useState<string | null>(
    getInitialDate(initialDate, defaultToCurrent)
  );

  const selectDate = (selectedDate: Date | string | null) => {
    setDate(selectedDate ? getDateString(selectedDate) : null);
  };

  const resetDate = () =>
    setDate(getInitialDate(initialDate, defaultToCurrent));

  const clearDate = () => setDate(null);

  return [date, selectDate, { resetDate, clearDate }] as const;
}
